<!-- Screenname: Surgery Mapping Creation
Developer Name: Antony.
Created date on: 22/11/2024 -->

<template>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="
      model
        ? $t('createsurgerymapping.EditDetails')
        : $t('createsurgerymapping.CreateSurgeryMapping')
    "
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col lg="12" md="12" sm="12">
          <div class="field">
            <TextField
              v-model="ObjMaster.Name"
              type="text"
              :label="$t('createsurgerymapping.Name')"
              clearable
              id="Name"
              name="Name"
              :rules="{ required: true }"
              :required-icon="true"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" md="12" sm="12">
          <div class="field">
            <MultiSelectDropDown
              v-model="ObjBrandModel.Brand"
              :id="$t('createsurgerymapping.Brand')"
              :name="$t('createsurgerymapping.Brand')"
              :label="$t('createsurgerymapping.Brand')"
              :required-icon="true"
              :rules="{ required: true }"
              :items="ObjBrandModel.BrandOption"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" md="12" sm="12">
          <div class="field">
            <MultiSelectDropDown
              v-model="ObjBrandModel.Model"
              :id="$t('createsurgerymapping.Model')"
              :name="$t('createsurgerymapping.Model')"
              :label="$t('createsurgerymapping.Model')"
              :required-icon="true"
              :rules="{ required: true }"
              :items="ObjBrandModel.ModelOption"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Footer
            @cancel="IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloading"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import axios from "axios";
import service from "../../../../Service/SurgeryMappingService";

import { useRoute } from "vue-router";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import MultiSelectDropDown from "../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import ItemConfigurationService from "../../../../../../modules/Inventory/Service/ItemConfiguration";

export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    axios,
    useRoute,
    TextField,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    MultiSelectDropDown,
  },
  setup(props, { emit }) {
    debugger;

    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;
    let EditBrand: any = ref([]);
    let EditModel: any = ref([]);
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let Saveloading = ref(false);

    const ObjMaster = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      Id: 0,
      Name: "",
      EntityId: 0,
      EntityOperationId: 0,
    });

    const ObjBrandModel = ref({
      Brand: ref(),
      BrandOption: [],
      Model: ref(),
      ModelOption: [],
    });

    const ObjMapping = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      Id: 0,
      SurgeryMasterId: "",
      ConfigurationTypeId: 0,
      ConfigurationId: 0,
    });

    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }

    onMounted(() => {
      debugger;
      LoadItemConfigurations();
    });

    async function LoadItemConfigurations() {
      debugger;
      try {
        const response = await ItemConfigurationService.List();
        ObjBrandModel.value.BrandOption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.ICTypeId == 1
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });

        ObjBrandModel.value.ModelOption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.ICTypeId == 2
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }

    //Clear Input Fields
    const copyObjMaster = JSON.parse(JSON.stringify(ObjMaster.value));
    function IsClear() {
      Object.assign(ObjMaster.value, copyObjMaster);
      ObjMaster.value.Id = 0;
      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");
    }

    // Add New PopUp
    function IsCreate() {
      debugger;
      showDialog.value = true;
    }

    //Row Edit

    async function IsEdit() {
      debugger;
      emit("loadershow");
      try {
        label.value = t("btn.update");
        const SurgeryMasterId = model.value.Id;
        const response = await service.GetById(SurgeryMasterId);
        const data = response["result"];

        Object.keys(ObjMaster.value).forEach((key) => {
          if (data[key]) ObjMaster.value[key] = data[key];
        });

        const response1 = await service.ListBySurgeryMasterId(SurgeryMasterId);

        const data1 = response1["result"];

        Object.values(data1).forEach((item: any) => {
          debugger;
          if (item.ConfigurationTypeId == 1) {
            EditBrand.value.push(item.ConfigurationId);
          }

          if (item.ConfigurationTypeId == 2) {
            EditModel.value.push(item.ConfigurationId);
          }
        });

        ObjBrandModel.value.Brand = EditBrand;
        ObjBrandModel.value.Model = EditModel;

        emit("loaderhide");
        showDialog.value = true;
      } catch (error) {
        emit("loaderhide");
        alert(error);
      }
    }

    //Save
    const IsSubmit = async () => {
      debugger;
      emit("loadershow");
      Saveloading.value = true;
      let SurgeryMasterId;
      let MasterResponse;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        let msg = "";
        ObjMaster.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjMaster.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        ObjMaster.value.HospitalId = HospitalId;
        ObjMaster.value.ModifiedBy = UserId;
        ObjMaster.value.CreatedBy = UserId;
        ObjMaster.value.EntityId = Number(Entitydata.value.EntityId);

        if (ObjMaster.value.Id != 0) {
          ObjMaster.value.EntityOperationId = props.OperationID.UpdateId;
          MasterResponse = await service.Update(ObjMaster.value);
          console.log(MasterResponse);
          msg = MasterResponse["ErrorInfo"].ErrorCode;
          if (MasterResponse["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            SurgeryMasterId = ObjMaster.value.Id;
          }
        } else {
          ObjMaster.value.EntityOperationId = props.OperationID.CreateId;

          MasterResponse = await service.Create(ObjMaster.value);
          console.log(MasterResponse);
          msg = MasterResponse["ErrorInfo"].ErrorCode;

          if (MasterResponse["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else {
            Saveloading.value = false;
            SurgeryMasterId = MasterResponse["result"];
          }
        }

        if (SurgeryMasterId && msg == null) {
          let BrandArray: any = [];
          let ModelArray: any = [];

          for (let i = 0; i < ObjBrandModel.value.Brand.length; i++) {
            let obj1 = {};

            if (ObjBrandModel.value.Brand[i] != null) {
              let BrandData = ObjBrandModel.value.BrandOption.find(
                (item) => item?.["Id"] == ObjBrandModel.value.Brand[i]
              );

              obj1["ConfigurationTypeId"] = BrandData?.["ICTypeId"];
            }

            (obj1["SurgeryMasterId"] = SurgeryMasterId),
              (obj1["ConfigurationId"] = ObjBrandModel.value.Brand[i]),
              (obj1["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj1["CreatedBy"] = UserId),
              (obj1["ModifiedAt"] = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              )),
              (obj1["ModifiedBy"] = UserId),
              (BrandArray[i] = obj1);
          }

          for (let i = 0; i < ObjBrandModel.value.Model.length; i++) {
            let obj2 = {};

            if (ObjBrandModel.value.Model[i] != null) {
              let ModelData = ObjBrandModel.value.ModelOption.find(
                (item) => item?.["Id"] == ObjBrandModel.value.Model[i]
              );

              obj2["ConfigurationTypeId"] = ModelData?.["ICTypeId"];
            }

            (obj2["SurgeryMasterId"] = SurgeryMasterId),
              (obj2["ConfigurationId"] = ObjBrandModel.value.Model[i]),
              (obj2["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj2["CreatedBy"] = UserId),
              (obj2["ModifiedAt"] = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              )),
              (obj2["ModifiedBy"] = UserId),
              (ModelArray[i] = obj2);
          }

          if (BrandArray.length > 0 && ModelArray.length > 0) {
            BrandArray = [...BrandArray, ...ModelArray];

            const MappingResponse = await service.MappingCreate(BrandArray);
            msg = MappingResponse["ErrorInfo"].ErrorCode;
          } else {
            Saveloading.value = false;
            alert("Somthing went wrong");
          }
        }

        emit("loaderhide");
        if (
          MasterResponse["result"] != "Already" &&
          ObjMaster.value.Id != 0 &&
          msg == null
        ) {
          Saveloading.value = false;
          updatepop.value = true;
        } else if (
          MasterResponse["result"] != "Already" &&
          SurgeryMasterId &&
          msg == null
        ) {
          Saveloading.value = false;
          successpop.value = true;
        }
      } catch (error) {
        emit("loaderhide");
        Saveloading.value = false;
        alert(error);
      }
    };

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      IsClear();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      ObjMaster.value.Name = "";
    }

    return {
      model,
      showModal: ref(false),
      ObjMaster,
      ObjMapping,
      ObjBrandModel,
      IsSubmit,
      IsEdit,
      IsClear,

      showDialog,
      IsCreate,
      successpop,
      updatepop,
      alreadyexistpop,
      closetrigger,
      alreadyclosetrigger,
      label,
      Saveloading,
    };
  },
});
</script>
